// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"11d13c3e","239":"4945362e","455":"3f6530a3"}[chunkId] + ".chunk.js";
};